/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_ProjectInputs */

const en_open_project = /** @type {(inputs: Open_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Project...`)
};

const fr_open_project = /** @type {(inputs: Open_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir un projet...`)
};

const de_open_project = /** @type {(inputs: Open_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt öffnen...`)
};

const it_open_project = /** @type {(inputs: Open_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri progetto...`)
};

const ru_open_project = /** @type {(inputs: Open_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открытый проект...`)
};

const es_open_project = /** @type {(inputs: Open_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto abierto...`)
};

const zh_cn2_open_project = /** @type {(inputs: Open_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开放项目...`)
};

const ja_open_project = /** @type {(inputs: Open_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを開く...`)
};

const hi_open_project = /** @type {(inputs: Open_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओपन प्रोजेक्ट...`)
};

const pt_pt2_open_project = /** @type {(inputs: Open_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto aberto...`)
};

/**
* | output |
* | --- |
* | "Open Project..." |
*
* @param {Open_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_project = /** @type {((inputs?: Open_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_open_project(inputs)
	if (locale === "de") return de_open_project(inputs)
	if (locale === "it") return it_open_project(inputs)
	if (locale === "ru") return ru_open_project(inputs)
	if (locale === "es") return es_open_project(inputs)
	if (locale === "zh-CN") return zh_cn2_open_project(inputs)
	if (locale === "ja") return ja_open_project(inputs)
	if (locale === "hi") return hi_open_project(inputs)
	if (locale === "pt-PT") return pt_pt2_open_project(inputs)
	return en_open_project(inputs)
});